import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const URL_PARAM_COUNTRY_KEY = 'country';

/**
 * @typedef {Object} Url
 * @property {string} pathname
 * @property {URLSearchParams} params
 */

/**
 * A wrapper around the `useLocation` hook that allows for easier interaction
 * with its URL parameters.
 * @returns {Url} An object containing the currentl URL pathname and the parameters.
 */
export const useUrl = (): { pathname: string; params: URLSearchParams } => {
  const { pathname, search } = useLocation();
  const params = useMemo(() => new URLSearchParams(search), [search]);
  overwriteCountryCodeCasingHack(params);

  return { pathname, params };
};

/**
 * HACK:
 * App expects the country URL parameter to be uppercase everywhere in the app.
 * This acts as a quick fix in lieu of an overhaul of our type system.
 */
const overwriteCountryCodeCasingHack = (params: URLSearchParams) => {
  const country = params.get(URL_PARAM_COUNTRY_KEY);
  if (country) {
    params.set(URL_PARAM_COUNTRY_KEY, country.toUpperCase());
  }
};
